import { render, staticRenderFns } from "./mo-checkbox-wrapper.html?vue&type=template&id=c8fa2a02&scoped=true&external"
import script from "./mo-checkbox-wrapper.ts?vue&type=script&lang=ts&external"
export * from "./mo-checkbox-wrapper.ts?vue&type=script&lang=ts&external"
import style0 from "./mo-checkbox-wrapper.scss?vue&type=style&index=0&id=c8fa2a02&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8fa2a02",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/agent/_work/3/s/Be.Vlaanderen.Mo.Vue/ClientApp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c8fa2a02')) {
      api.createRecord('c8fa2a02', component.options)
    } else {
      api.reload('c8fa2a02', component.options)
    }
    module.hot.accept("./mo-checkbox-wrapper.html?vue&type=template&id=c8fa2a02&scoped=true&external", function () {
      api.rerender('c8fa2a02', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/shared/mo-checkbox-wrapper/mo-checkbox-wrapper.vue"
export default component.exports